import { MessageTypes } from '../store/declarations/enums/common/declaration-types';
import { DeclarationCountry } from '../store/declarations/enums/common/declaration-country';
import { DeclarationInternalType } from 'store/declarations/enums/common/declaration-internal-type';
import { startCase } from 'lodash';

export const getDeclarationTitle = (
    country: DeclarationCountry,
    internalType: DeclarationInternalType,
    messageType: MessageTypes
) => {
    if (!country || !internalType || !messageType) return '';

    if (country.toLowerCase() === DeclarationCountry.EU) return `ICS2 ENS ${messageType}`;

    const fmtCountry = country.toLowerCase() === DeclarationCountry.IRELAND ? 'Irish' : 'UK';
    const fmtInternalType =
        internalType.toUpperCase() === DeclarationInternalType.IMPORT_NEW
            ? 'Import'
            : startCase(internalType.toLowerCase());
    const fmtMessageType = messageType === ('ENS' as MessageTypes) ? '' : ` ${messageType}`;

    return `${fmtCountry} ${fmtInternalType}${fmtMessageType}`;
};
